import { Teaser as t } from '@xprog/prensa/types'

export const TeaserMostRead: t.TeaserProps = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px',
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
}